module.exports = __webpack_public_path__ + "media/images/profile-03-6ed4fbb579acea2bf12fedc99205ef5e.png";